var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 113,
    viewBox: "0 0 128 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.9989 33.9065C99.4182 32.9155 106.361 24.096 106.958 10.0036C107.005 8.89997 106.099 7.99924 104.995 8.00106C87.416 8.03005 87.0093 8.8491 87.0002 31.9903C86.9998 33.0949 87.8993 34.0111 88.9989 33.9065Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2163 32.4686C95.2846 39.1354 106.43 37.8082 116.817 28.2658C117.631 27.5185 117.627 26.2413 116.845 25.4615C104.394 13.0519 103.528 13.3435 87.158 29.7004C86.3766 30.4811 86.3648 31.765 87.2163 32.4686Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 112.24V82.1284C0 58.9286 9.96717 37.5632 17.2134 34.1967C49.5 19.1966 77 19.1966 111.257 34.6282C120.224 38.6678 128 68.1282 128 82.1284V112.24C126.847 111.394 125.503 110.766 123.948 110.393C123.983 109.045 124 107.683 124 106.306C124 59.9238 104.169 35 64 35C23.8312 35 4 59.9238 4 106.306C4 107.683 4.01747 109.045 4.05241 110.393C2.49732 110.766 1.15329 111.394 0 112.24Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1973 39.9855C91.7266 37.001 92 33.8722 92 30.6479C92 10.0189 80.814 0 62.9155 0C45.0166 0 33 10.0189 33 30.6479C33 34.325 33.3818 37.878 34.1108 41.2343C42.3633 37.1064 52.3223 35 64 35C74.4355 35 83.498 36.6821 91.1973 39.9855Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairS);
export default __webpack_public_path__ + "static/media/Hair S.ae777218e3c920f3b28e65b9c636c998.svg";
export { ForwardRef as ReactComponent };